import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { Card, CardContent, Grid } from '@mui/material';

export default function SkeletonCard() {
    return (
        <Box sx={{ overflow: 'hidden' }}>
            <Box sx={{ marginRight: 0.5 }}>
                <Skeleton variant="rectangular" width={'100%'} height={200} />
                <Box sx={{ pt: 0.5 }}>
                    <Skeleton />
                    <Skeleton width="60%" />
                </Box>
            </Box>
        </Box>
    );
}
export const SkeletonWaveCard = () => {
    return (
        <Skeleton variant="rectangular" height={60} className="mb-3" animation="wave" />
    );
}
export const SkeletonSection = () => {
    return (
        <Card sx={{ mb: 4 }}>
            <CardContent>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                    <Skeleton variant="text" width={120} height={32} />
                    <Skeleton variant="rectangular" width={180} height={36} sx={{ borderRadius: 2 }} />
                </Box>
                <Grid container spacing={3}>
                    {[1, 2, 3].map((item) => (
                        <Grid item xs={12} md={6} lg={4} key={item}>
                            <Card>
                                <CardContent>
                                    <Skeleton variant="text" width="80%" height={24} />
                                    <Skeleton variant="text" width="60%" height={20} sx={{ mt: 1 }} />
                                    <Skeleton variant="text" width="50%" height={20} />
                                    <Box sx={{ mt: 2 }}>
                                        <Skeleton variant="text" width="40%" height={16} />
                                        <Skeleton variant="rectangular" width="100%" height={8} sx={{ mt: 1, borderRadius: 4 }} />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    )
}

export const RectangularSkeleton = () => {
    return (
        <Grid container spacing={3} sx={{ mb: 2 }}>
            {[1, 2, 3, 4].map((item) => (
                <Grid item xs={12} sm={6} md={3} key={item}>
                    <Card sx={{ backgroundColor: "#FFFFFF", borderRadius: "20px", height: "96px" }}>
                        <CardContent>
                            <Skeleton variant="text" width="60%" height={32} />
                            <Skeleton variant="text" width="40%" height={20} />
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    )
}

export const SkeletonBudgetCard = () => {
    return (
        <Card sx={{ height: '100%' }}>
            <CardContent>
                <Skeleton variant="rectangular" width={60} height={60} sx={{ mb: 2 }} />
                <Skeleton variant="text" width="60%" height={40} />
                <Skeleton variant="text" width="80%" />
                <Skeleton variant="rectangular" width="100%" height={80} sx={{ my: 2 }} />
                <Skeleton variant="text" width="40%" />
            </CardContent>
        </Card>
    )
}